import { periodQueryKeyMap } from '../cbsGraph.config';
import { WebAPIChartSlicerData } from '../../../globals/webApiTypes/elements/WebAPICBS';
import { CBSStatlineDataset } from '../cbsStatline.types';

export const convertCbsPeriodToDate = (
	cbsDataPoint: CBSStatlineDataset[number],
	{ dataSourceLanguage = 'nl', periodType }: WebAPIChartSlicerData,
) => {
	const periodQueryKey = periodQueryKeyMap[dataSourceLanguage];
	const cbsDateString = cbsDataPoint[periodQueryKey] as string;

	switch (periodType) {
		case 'Maanden': {
			const year = cbsDateString.slice(0, 4);
			const month = cbsDateString.slice(6, 8);
			return new Date(Date.UTC(Number(year), Number(month) - 1, 1, 0, 0, 0));
		}
		case 'Kwartalen': {
			const year = cbsDateString.slice(0, 4);
			const quarterInMonths = (Number(cbsDateString.slice(6, 8)) - 1) * 3;
			return new Date(
				Date.UTC(Number(year), Number(quarterInMonths), 1, 0, 0, 0),
			);
		}
		case 'Jaar': {
			const year = cbsDateString.slice(0, 4);
			return new Date(Date.UTC(Number(year), 0, 1, 0, 0, 0));
		}
		default:
			throw new Error(`Could not convert CBS date string: '${cbsDateString}'`);
	}
};
